export default "__VITE_ASSET__DOOo9JO0__"